import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
import(/* webpackMode: "eager" */ "/app/src/app/hacker-mode.css");
import(/* webpackMode: "eager" */ "/app/node_modules/katex/dist/katex.min.css");
import(/* webpackMode: "eager" */ "/app/node_modules/normalize.css/normalize.css");
import(/* webpackMode: "eager" */ "/app/src/components/DocumentBodyGuard/DocumentBodyGuard.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/DomMutationGuard/DomMutationGuard.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/TelemetryInit/TelemetryInit.tsx")